import React from "react";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTheme } from "@mui/material/styles";

import { useFormContext, Controller } from "react-hook-form";
import { inputLabelStyles } from "../styles";

const ProjectContentViolence = () => {
  const theme = useTheme();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <React.Fragment>
      <Grid xs={4}>
        <FormControl fullWidth>
          <InputLabel {...inputLabelStyles(theme)}>Violence</InputLabel>
          <Controller
            control={control}
            name="violence"
            render={({ field }) => (
              <Select
                id="violence"
                fullWidth
                label="Violence"
                defaultValue="None"
                sx={{ backgroundColor: theme.palette.background.paper }}
                {...register("violence", { required: true })}
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Mild">Mild</MenuItem>
                <MenuItem value="Moderate">Moderate</MenuItem>
                <MenuItem value="Explicit">Explicit</MenuItem>
              </Select>
            )}
          />
        </FormControl>

        <FormControl fullWidth>
          <InputLabel {...inputLabelStyles(theme)}>Gore</InputLabel>
          <Controller
            control={control}
            name="gore"
            render={({ field }) => (
              <Select
                id="gore"
                fullWidth
                label="Gore"
                defaultValue="None"
                sx={{ backgroundColor: theme.palette.background.paper }}
                {...register("gore", { required: true })}
              >
                <MenuItem value="None">None</MenuItem>
                <MenuItem value="Mild">Mild</MenuItem>
                <MenuItem value="Moderate">Moderate</MenuItem>
                <MenuItem value="Explicit">Explicit</MenuItem>
              </Select>
            )}
          />
        </FormControl>
      </Grid>
    </React.Fragment>
  );
};

export default ProjectContentViolence;
